import { render, staticRenderFns } from "./PermissionTitle.vue?vue&type=template&id=f77cda7e&"
import script from "./PermissionTitle.vue?vue&type=script&lang=js&"
export * from "./PermissionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports